import { render, staticRenderFns } from "./ProductCategoriesList.vue?vue&type=template&id=69bca834&scoped=true&"
import script from "./ProductCategoriesList.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bca834",
  null
  
)

export default component.exports